<template>
  <div class="enterprise-partner">
    <div class="opreationBox">
      <el-form
        size="mini"
        :inline="true"
        :model="params"
        label-width="140px"
        class="demo-form-inline"
        @submit.native.prevent
      >
<!--        <el-form-item label="二级合伙人编号">-->
<!--          <el-input placeholder="请输入" clearable v-model="params.code" />-->
<!--        </el-form-item>-->
        <el-form-item label="二级合伙人姓名">
          <el-input placeholder="请输入" clearable v-model="params.partnerName" />
        </el-form-item>
        <el-form-item label="">
          <el-button style="width:98px" type="primary" @click="search">查 询</el-button>
          <el-button style="width:98px" type="danger" plain @click="reset">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        border
        size="mini"
        :data="data"
        v-loading="loading"
        style="width: 100%"
      >
<!--        <el-table-column label="二级合伙人编号" align="center" prop="code" />-->
        <el-table-column label="二级合伙人微信名" align="center" prop="nickName" />
        <el-table-column label="二级合伙人生效状态" align="center" prop="state">
          <template slot-scope="{ row }">
            {{ row.state === 0 ? '有效' : (row.state === 1 ? '无效' : '') }}
          </template>
        </el-table-column>
        <el-table-column label="二级合伙人姓名" align="center" prop="name" />
        <el-table-column label="电话" align="center" prop="phoneNumber" />
        <el-table-column label="加盟日期" align="center" prop="createTime" />
        <el-table-column label="会员数量" align="center" prop="panelCount" />
        <el-table-column label="会员关注数" align="center" prop="panelFocusCount" />
        <el-table-column label="操作" align="center" prop="developerName">
          <template slot-scope="scope">
            <el-button plain size="mini" @click="look(scope.row)" style="margin-bottom: 10px;">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox" style="margin-top: 10px;width: 100%;text-align: right;">
      <el-pagination
        background
        @size-change="partnerSizeChange"
        @current-change="partnerCurrentChange"
        :current-page="params.pageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { getEnterpriseMember as getList } from 'api/request'
  export default {
    data() {
      return {
        params: {
          enterpriseId: undefined,
          pageIndex: 1,
          pageSize: 10,
          code: undefined,
          partnerName: undefined
        },
        loading: false,
        total: 0,
        data: []
      }
    },
    methods: {
      initData(enterpriseId) {
        this.params.enterpriseId = enterpriseId
        this.getList()
      },
      async getList() {
        this.loading = true
        const res = await getList(this.params)
        if (res) {
          const { rows, total } = res
          this.data = Array.isArray(rows) ? rows : []
          this.total = total && total > 0 ? total : 0
        }
        this.loading = false
      },
      partnerSizeChange(val) {
        this.params.pageSize = val
        this.getList()
      },
      partnerCurrentChange(val) {
        this.params.pageIndex = val
        this.getList()
      },
      search() {
        this.params.pageIndex = 1
        this.getList()
      },
      reset() {
        Object.assign(this.$data.params, this.$options.data().params)
        this.getList()
      },
      look(row) {
        const { id } = row
        this.$router.push({ path: '/partnerDetail', query: { id }})
      }
    }
  }
</script>
